import i from "classnames";
import u, { useMemo as d } from "react";
const b = ({
  children: o,
  className: n,
  color: p,
  dataTestId: s = null,
  disableMargin: f = !1,
  noWrap: y = !1,
  size: t = "7",
  tag: g,
  type: a = "heading",
  ...l
}) => {
  const m = g || {
    display: "h1",
    heading: "h1",
    paragraph: "p"
  }[a], c = d(() => {
    if (!t) return "";
    if (typeof t == "string" || typeof t == "number") return `fs-${t}`;
    if (typeof t != "object") return "";
    const r = [];
    return Object.entries(t).forEach(([h, e]) => {
      (typeof e == "string" || typeof e == "number") && r.push(`fs-${h}-${e}`);
    }), r.join(" ");
  }, [t]);
  return u.createElement(
    m,
    {
      className: i(
        n,
        c,
        f && "tvg-typography--disable-margin",
        y && "tvg-typography--no-wrap",
        "tvg-typography",
        `fv-${a}`,
        "fuse-typography-element"
      ),
      "data-testid": s,
      style: { color: p },
      ...l
    },
    o
  );
};
b.displayName = "TypographyComponent";
export {
  b as TypographyComponent
};
